<template>
  <div class="site-wrapper__inner">

    <div class="main__wrapper">

      <main
        class="main new__errand"
        v-if="createdErrand"
      >
        <v-btn
          class="ml-0"
          color="primary"
          @click="$router.push('/')"
        >
          <v-icon
            left
            dark
          >keyboard_arrow_left</v-icon>
          {{ $t('errands.allErrands') }}
        </v-btn>
        <div class="page__indicator">
          <div
            class="page__number"
            :class="{'state--active': currentPage === 1}"
          >
            <div>1</div>
            <div>{{ $t('createErrand.tenantDetails') }}</div>
          </div>
          <div class="page__connector"></div>
          <div
            class="page__number"
            :class="{'state--active': currentPage === 2}"
          >
            <div>2</div>
            <div>{{ $t('createErrand.caseDetails') }}</div>
          </div>
        </div>

        <div
          class="form__page"
          v-show="currentPage === 1"
        >
          <div class="form">
            <h3>{{ $t('createErrand.tenantDetails') }}</h3>

            <v-form
              ref="form1"
              v-model="form1.valid"
            >

              <section>

                <PolygonPlace
                  :place-id="get(createdErrand, 'request.dmg_place.placeId')"
                  :rules="rules"
                  :translate-optional="translateOptional"
                  event-key="dmg_place"
                />

                <div class="form__items">
                  <div class="form__item">
                    <v-textarea
                      auto-grow
                      rows="1"
                      :label="translateOptional('additionalInformation')"
                      v-model="createdErrand.request.additional_note"
                      required
                    ></v-textarea>
                  </div>
                </div>
              </section>

              <h3>{{ $t('createErrand.billingAddress') }}</h3>

              <section>
                <div class="form__items">
                  <div class="form__item">
                    <v-radio-group v-model="form1.billingAddressOption">
                      <v-radio
                        :label="$t('createErrand.sameAsTenant')"
                        :value="billingAddressOption.sameAsTenant"
                        color="primary"
                      ></v-radio>
                      <v-radio
                        v-if="isBusinessPartner"
                        :label="$t('createErrand.sameAsCompany')"
                        :value="billingAddressOption.sameAsPrpmgtCompany"
                        color="primary"
                      ></v-radio>
                      <v-radio
                        :label="$t('createErrand.differentAddress')"
                        :value="billingAddressOption.different"
                        color="primary"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                </div>
              </section>

              <section v-if="!useDifferentBillingAddress">
                <div class="form__items">
                  <div class="form__item">
                    <v-text-field
                      :label="$t('createErrand.streetAddress')"
                      autocomplete="new-password"
                      v-model="billToAddress.address"
                      :rules="differentBillingAddressRule"
                      disabled
                    ></v-text-field>
                  </div>

                  <div class="form__item">
                    <v-text-field
                      :label="$t('createErrand.city')"
                      autocomplete="new-password"
                      v-model="billToAddress.city"
                      :rules="rules.city"
                      disabled
                    ></v-text-field>
                  </div>
                </div>

                <div class="form__items">
                  <div class="form__item">
                    <v-text-field
                      :label="$t('createErrand.postalCode')"
                      autocomplete="new-password"
                      v-model="billToAddress.zip_code"
                      :rules="postalCodeRule"
                      disabled
                    ></v-text-field>
                  </div>
                </div>
              </section>
              <section v-else>
                <PolygonPlace
                  :place-id="get(createdErrand, 'request.alt_place.placeId')"
                  :rules="rules"
                  :translate-optional="translateOptional"
                  event-key="alt_place"
                />
              </section>

            </v-form>
          </div>
        </div>

        <div
          class="form__page"
          v-show="currentPage === 2"
        >
          <div class="form">
            <h3>{{ $t('createErrand.caseDetails') }}</h3>

            <v-form
              v-model="form2.valid"
              ref="form2"
            >
              <section>
                <div class="form__items">
                  <div class="form__item">
                    <v-select
                      class="default-color"
                      :label="$t('createErrand.typeOfDamage')"
                      :items="workTypes"
                      v-model="createdErrand.request.work_type"
                      :rules="rules.required"
                    ></v-select>
                  </div>
                </div>

                <div class="form__items">
                  <div class="form__item">
                    <v-text-field
                      :label="translateOptional('propertyId')"
                      v-model="createdErrand.request.property_id"
                    ></v-text-field>
                  </div>

                  <div class="form__item">
                    <v-textarea
                      auto-grow
                      rows="1"
                      :label="translateOptional('projectNote')"
                      v-model="createdErrand.request.note"
                    ></v-textarea>
                  </div>
                </div>

                <div class="form__items">
                  <div class="form__item">
                    <v-textarea
                      auto-grow
                      rows="1"
                      :label="$t('createErrand.workDescription')"
                      v-model="createdErrand.request.cust_prob_descr"
                      :rules="rules.required"
                    ></v-textarea>
                  </div>
                  <div class="form__item">
                    <v-text-field
                      v-model="createdErrand.request.conseq_dmg_note"
                      :label="translateOptional('consequentialDamage')"
                    ></v-text-field>
                  </div>
                </div>
              </section>

              <h3>{{ $t('createErrand.insuranceRelatedCase') }}</h3>

              <section>
                <div class="form__items">
                  <div class="form__item">
                    <v-radio-group v-model="form2.insuranceRelatedCase">
                      <v-radio
                        :label="$t('createErrand.no')"
                        :value="0"
                        color="primary"
                      ></v-radio>
                      <v-radio
                        :label="$t('createErrand.yes')"
                        :value="1"
                        color="primary"
                      ></v-radio>
                    </v-radio-group>
                  </div>
                </div>
              </section>

              <section v-if="form2.insuranceRelatedCase == 1">
                <div class="form__items">
                  <div class="form__item">

                  </div>
                </div>

                <div class="form__items">
                  <div class="form__item">

                    <v-menu
                      ref="menu"
                      v-model="datepickerMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="createdErrand.request.dmg_date"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >

                    <template v-slot:activator="{ on }">
                      <v-text-field
                        slot="activator"
                         v-on="on"
                        v-model="formattedDate"
                        :rules="[v => form2.insuranceRelatedCase == 1 && !!v || $t('createErrand.requiredField')]"
                        :label="$t('createErrand.damageDate')"
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                    </template>
                      <v-date-picker
                        color="primary"
                        v-model="createdErrand.request.dmg_date"
                        no-title
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          @click="$refs.menu.save(createdErrand.request.dmg_date)"
                        >OK</v-btn>
                      </v-date-picker>
                    </v-menu>

                  </div>

                  <div class="form__item">
                    <v-text-field
                      :label="$t('createErrand.insuranceClaimNo')"
                      v-model="createdErrand.request.claim_no"
                      :rules="[v => form2.insuranceRelatedCase == 1 && !!v || $t('createErrand.requiredField')]"
                    ></v-text-field>
                  </div>
                </div>
                <div class="form__items">
                  <div class="form__item">
                    <v-text-field
                      :label="$t('createErrand.insuranceCompany')"
                      :rules="[v => form2.insuranceRelatedCase == 1 && !!v || $t('createErrand.requiredField')]"
                      v-model="createdErrand.request.insurance_co"
                    ></v-text-field>
                  </div>

                  <div class="form__item">
                    <v-text-field
                      :label="translateOptional('insurancePolicyNo')"
                      v-model="createdErrand.request.policy_no"
                    ></v-text-field>
                  </div>
                </div>
              </section>
            </v-form>
          </div>
        </div>

        <div class="button__container">
          <button
            class="button--secondary back"
            @click="prevPage"
            v-if="currentPage > 1"
          >
            <i class="icon-right"></i> {{ $t('createErrand.back') }}
          </button>
          <button
            class="button--secondary next"
            @click="nextPage"
            v-if="currentPage < 2"
          >
            {{ $t('createErrand.next') }}
            <i class="icon-right"></i>
          </button>
          <button
            class="button--secondary next"
            @click="createCase"
            :disabled="loading"
            v-if="currentPage === 2"
          >{{ $t('createErrand.createCase') }}</button>
        </div>

        <vue-json-pretty
          v-if="isDevelopment"
          :data="createdErrand"
        ></vue-json-pretty>

      </main>
    </div>
  </div>
</template>

<script>
import toasts from '@/core/toasts'
import _ from 'lodash'
import constants from '@/core/constants'
import validationService from '@/core/validation-service'
import submitErrandService from '@/core/services/submit-errand-service'
import utils from '@/core/utils'
import VueJsonPretty from 'vue-json-pretty'
import repository from '@/core/repository/repository'
import localizationService from '@/core/services/localization-service'
import moment from 'moment'
import { postcodeValidator, postcodeValidatorExistsForCountry } from 'postcode-validator'

export default {
  data() {
    return {
      createdErrand: null,
      loading: false,
      datepickerMenu: false,
      billingAddressOption: {
        sameAsTenant: 1,
        sameAsPrpmgtCompany: 2,
        different: 3
      },
      form1: {
        valid: false,
        billingAddressOption: 1
      },
      form2: {
        valid: false,
        insuranceRelatedCase: 0
      },
      currentPage: 1
    }
  },
  mounted() {
    _.forEach(['dmg_place', 'alt_place'], addressEventKey => {
      this.subscribe(`address.${addressEventKey}.changed`, value => {
        const isExistingAddress = _.isObject(value)
        const addresses =
          addressEventKey === 'dmg_place'
            ? [
              this.getAddress(constants.addressType.billTo),
              this.getAddress(constants.addressType.default)
            ]
            : [this.createdErrand.request[addressEventKey].address]

        if (isExistingAddress) {
          this.createdErrand.request[addressEventKey].placeId = value.place_id
          this.publish(`update.newerrand.address.${addressEventKey}`, {
            zip_code: value.postal_code,
            city: value.city
          })
        } else {
          this.createdErrand.request[addressEventKey].placeId = null
        }
        _.forEach(addresses, address => {
          address.address = isExistingAddress ? value.address : value
        })
      })
    })
    this.subscribe(`newerrand.place.dmg_place.updated`, damagePlace => {
      _.assignIn(this.createdErrand.request.dmg_place, damagePlace)
    })
    this.subscribe(
      `newerrand.address.dmg_place.updated`,
      damagePlaceAddress => {
        if (
          this.form1.billingAddressOption ===
          this.billingAddressOption.sameAsTenant
        ) {
          _.assignIn(this.defaultAddress, damagePlaceAddress)
        }
      }
    )
    this.subscribe(`newerrand.place.alt_place.updated`, altPlace => {
      _.assignIn(this.createdErrand.request.alt_place, altPlace)
    })
    this.subscribe(`newerrand.address.alt_place.updated`, altPlaceAddress => {
      _.assignIn(this.createdErrand.request.alt_place.address, altPlaceAddress)
    })
  },
  methods: {
    nextPage() {
      if (this.$refs.form1.validate()) {
        this.currentPage++
      }
      this.scrollToTop()
    },
    prevPage() {
      this.currentPage--
      this.scrollToTop()
    },
    createCase() {
      if (!this.$refs.form2.validate()) {
        this.scrollToTop()
        return
      }
      this.loading = true
      submitErrandService
        .submit(this.createdErrand)
        .done(validationResult => {
          toasts.success(this.$t('createErrand.submitSuccess'))
          this.$router.push({ path: '/' })
          this.resetForm()
        })
        .fail(() => {
          toasts.error(this.$t('createErrand.submitError'))
        })
        .always(() => {
          this.loading = false
        })
    },
    resetForm() {
      this.$store.dispatch('deleteEntity', {
        type: 'createdErrand',
        key: this.createdErrand.request.external_id_1
      })
      this.currentPage = 1
      this.form1.billingAddressOption = this.billingAddressOption.sameAsTenant
      this.form2.insuranceRelatedCase = 0
      this.createdErrand = null
    },
    scrollToTop() {
      utils.scrollTo(0)
    },
    translateOptional(key) {
      return (
        this.$t(`createErrand.${key}`) +
        ' (' +
        this.$t('createErrand.optional') +
        ')'
      )
    },
    getAddress(type) {
      const addresses = _.get(
        this,
        'createdErrand.request.dmg_place.addresses',
        []
      )
      return _.find(addresses, ['address_type', type])
    },
    mergeBillingWithDefaultAddress() {
      if (this.defaultAddress) {
        this.setBillingAddress(
          this.defaultAddress.address,
          this.defaultAddress.zip_code,
          this.defaultAddress.city
        )
      }
    },
    setBillingAddress(address, zipCode, city) {
      this.billToAddress.address = address
      this.billToAddress.city = city
      this.billToAddress.zip_code = zipCode
    }
  },
  activated() {
    const createdErrand = this.$store.getters.createdErrand[this.$route.params.external_id_1]
    if (!createdErrand) {
      this.$router.push({ path: '/' })
    }
    this.createdErrand = createdErrand
  },
  computed: {
    workTypes() {
      return _.map(this.$store.getters.workTypes, workType => ({
        text: workType.description,
        value: workType.id
      }))
    },
    defaultAddress() {
      return this.getAddress(constants.addressType.default)
    },
    billToAddress() {
      return this.getAddress(constants.addressType.billTo)
    },
    rules() {
      return {
        required: [v => !!v || this.$t('createErrand.requiredField')],
        postalCodeRule: this.postalCodeRule,
        city: [v => (!!v && !!/^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$/.test(v)) || this.$t('createErrand.invalidFormat')],
        email: [
          v =>
            !v ||
            validationService.validateEmail(v) ||
            this.$t('createErrand.invalidFormat')
        ],
        phone: [
          v =>
            validationService.validatePhoneNumber(v) ||
            this.$t('createErrand.invalidFormat')
        ],
        optionalPhone: [
          v =>
            !v ||
            validationService.validatePhoneNumber(v) ||
            this.$t('createErrand.invalidFormat')
        ]
      }
    },
    postalCodeRule() {
      const currentUnitCountry = localizationService.getCountryByCompany(this.currentUserCompany)
      return [v => {
        if(postcodeValidatorExistsForCountry(currentUnitCountry)) {
          return postcodeValidator(v, currentUnitCountry) || this.$t('createErrand.invalidFormat')
        }
        return !!v || this.$t('createErrand.invalidFormat')
      }]
    },
    differentBillingAddressRule() {
      return !this.useDifferentBillingAddress ? this.rules.required : []
    },
    useDifferentBillingAddress() {
      return (
        this.form1.billingAddressOption === this.billingAddressOption.different
      )
    },
    enableCreateCase() {
      return !this.loading && this.form1.valid && this.form2.valid
    },
    formattedDate() {
      const damageDate = this.createdErrand.request.dmg_date
      if(moment(damageDate).isValid()) { return moment.utc(damageDate).format('LLL') }
      return null
    }
  },
  watch: {
    useDifferentBillingAddress(useDifferent) {
      if (!this.createdErrand) {
        return
      }
      if (!useDifferent) {
        this.createdErrand.request.alt_place = null
      } else {
        this.createdErrand.request.alt_place = repository.create('altPlace', {
          address: {
            address_type: constants.addressType.default,
            country: localizationService.getCountryByCompany(
              this.currentUserCompany
            )
          }
        })
      }
    },
    'form1.billingAddressOption'(option) {
      switch (option) {
        case this.billingAddressOption.sameAsTenant:
          this.mergeBillingWithDefaultAddress()
          break
        case this.billingAddressOption.sameAsPrpmgtCompany:
          this.setBillingAddress(
            this.currentUserCompany.address,
            this.currentUserCompany.postalCode,
            this.currentUserCompany.city
          )
          break
      }
      if (this.createdErrand) {
        this.createdErrand.request.place_id_to_bill =
          option === this.billingAddressOption.sameAsPrpmgtCompany
            ? this.currentUserCompany.polygonCustomerNumber
            : null
      }
    },
    'createdErrand.request.alt_place.address': {
      deep: true,
      handler(altPlaceAddress) {
        if (altPlaceAddress) {
          this.setBillingAddress(
            altPlaceAddress.address,
            altPlaceAddress.zip_code,
            altPlaceAddress.city
          )
        }
      }
    },
    defaultAddress: {
      deep: true,
      handler() {
        if (
          this.form1.billingAddressOption ===
          this.billingAddressOption.sameAsTenant
        ) {
          this.mergeBillingWithDefaultAddress()
        }
      }
    }
  },
  components: { VueJsonPretty }
}
</script>

<style lang="scss">
.new__errand {
  .main {
    padding: measure(xs);
  }

  .form {
    @include layout-box;
    padding: measure(xs);
  }

  h3 {
    flex-basis: 100%;
  }

  section {
    margin-top: 0;
  }

  .v-input--radio-group {
    margin-top: 0;
  }

  .button__container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-top: measure(m);
  }

  button.button--secondary {
    display: flex;
    width: auto;
  }

  button.next {
    margin-left: auto;
    i {
      transform: translateX(measure(s));
    }
  }

  button.back {
    // margin-right: auto;
    i {
      transform: rotate(180deg) translateX(measure(s));
    }
  }

  @media #{$mq-swapToDesktop} {
    .main {
      padding: measure(m);
    }

    .form {
      padding: measure(m);
    }

    .form__item {
      flex: 0 1 50%;
      width: 50%;
    }

    .form__items {
      display: flex;
      flex: 0 1 100%;
      width: 100%;
      flex-direction: row;
      flex-wrap: nowrap;

      > .form__item {
        flex: 0 1 50%;
        width: 50%;
      }

      > .form__item:first-child {
        padding-right: measure(s);
      }

      > .form__item:last-child {
        padding-left: measure(s);
      }

      > .form__item:only-child {
        padding-left: 0;
      }
    }
  }

  .page__indicator {
    display: flex;
    flex: 0 0 100%;
    width: 100%;
    margin: 1.5rem auto;
    justify-content: space-between;
    margin-bottom: measure(m);

    @media #{$mq-swapToDesktop} {
      flex: 0 0 50%;
      width: 50%;
    }
  }

  .page__connector {
    display: flex;
    flex: 1 1 100%;
    height: 0.1875rem;
    background-color: #b9c4d2;
    margin-top: 1.1875rem;
    margin-left: -15%;
    margin-right: -15%;
    z-index: 0;
  }

  @keyframes pulse {
    0% {
      transform: scale3d(1, 1, 1);
    }
    50% {
      transform: scale3d(1.2, 1.2, 1);
    }
    100% {
      transform: scale3d(1, 1, 1);
    }
  }

  .page__number {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 0 0 30%;
    z-index: 1;
    // color: color(subtle);

    &.state--active div:first-child {
      background-color: color(primary);
      animation: pulse 500ms ease 1 alternate;
    }

    div:first-child {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 2.5rem;
      height: 2.5rem;
      background-color: #b9c4d2;
      color: color(white);
      border-radius: 100%;
      margin-bottom: measure(xs);
      transition: all 500ms;
    }

    div:last-child {
      text-align: center;
      white-space: nowrap;
    }
  }

  .fade-enter-active {
    transition: all 300ms;
    max-height: 12.5rem;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0;
    max-height: 0;
  }
}
</style>
